<section class="faq-section">
  <div class="container">

    <!-- Header Block -->
    <div class="row mb-5">
      <div class="col-lg-8">
        <h1 class="faq-title">FAQ's</h1>
        <p class="section-intro">
          AIKosh enables interdisciplinary AI innovation beyond coding
        </p>
      </div>
    </div>

    <!-- Accordion Wrapper Box -->
    <div class="faq-accordion-box">
      
      <!-- Loop Wrapper Element Matrix -->
      <div class="faq-item" 
           *ngFor="let item of faqList; let i = index" 
           [class.active]="activeIndex === i">
        
        <!-- Header Toggle Trigger Strip Bar -->
        <button class="faq-header" (click)="toggleFaq(i)" type="button">
          <span class="faq-question">{{ item.question }}</span>
          <span class="faq-chevron">
            <i class="fa-solid" [ngClass]="activeIndex === i ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </span>
        </button>

        <!-- Rigid Containment Content Framework Block -->
        <div class="faq-collapse">
          <div class="faq-body">
            <p class="faq-answer">{{ item.answer }}</p>
          </div>
        </div>

      </div>

    </div>

  </div>
</section>
